import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core'
import {
	MAT_DIALOG_DATA,
	MatDialogRef,
	MatDialogTitle,
	MatDialogContent,
	MatDialogActions,
} from '@angular/material/dialog'
import { AppUser } from 'domain/user/app-user.model'
import { AppUsersFirestoreService } from '../../core/firestore-services/app-users-firestore.service'
import { CdkScrollable } from '@angular/cdk/scrolling'
import { NgIf, NgClass } from '@angular/common'
import { MatCheckbox } from '@angular/material/checkbox'
import { ReactiveFormsModule, FormsModule } from '@angular/forms'
import { TranslatePipe } from '@ngx-translate/core'

@Component({
	template: `
		<h2 matDialogTitle>{{ 'dialog.termeniHeader' | translate }}</h2>

		<mat-dialog-content>
			<pre class="description">{{ 'termeni' | translate }}</pre>
		</mat-dialog-content>

		<br />

		<mat-checkbox *ngIf="user" class="rounded-checkbox" color="primary" [(ngModel)]="agreed">
			{{ 'dialog.termeniPrompt' | translate }}
		</mat-checkbox>

		<div mat-dialog-actions style="justify-content: flex-end">
			<button
				mat-flat-button
				color="primary"
				class="btncontinue"
				[disabled]="!agreed"
				[ngClass]="[agreed ? '' : 'disabled']"
				(click)="close()"
			>
				{{ 'dialog.continua' | translate }}
			</button>
		</div>

		<br />
	`,
	styleUrls: ['./user-terms.dialog.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		MatDialogTitle,
		CdkScrollable,
		MatDialogContent,
		NgIf,
		MatCheckbox,
		ReactiveFormsModule,
		FormsModule,
		MatDialogActions,
		NgClass,
		TranslatePipe,
	],
})
export class UserTermsDialog {
	readonly user = inject<AppUser>(MAT_DIALOG_DATA)
	protected readonly dialogRef = inject<MatDialogRef<UserTermsDialog>>(MatDialogRef)
	private readonly appUsersFirestoreService = inject(AppUsersFirestoreService)

	/*no need to agree if user is not logged in (agree checkbox present in order-form)*/
	agreed: boolean = !this.user

	close(): void {
		if (this.user) {
			const user = { uid: this.user.uid, agreed: new Date().toISOString() } as AppUser
			this.appUsersFirestoreService.update(user).then(() => this.dialogRef.close())
		} else {
			this.dialogRef.close()
		}
	}
}
